import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters } from "@faire/web-api--source/routes/cart";
import pick from "lodash/pick";
var RELEVANT_QUERY_PARAMS = [
    "filters",
    "query"
];
export var useRelevantQueryParams = function() {
    return pick(useQueryParams(QueryParameters.parse), RELEVANT_QUERY_PARAMS);
};
export var SERVER_CART_QUERY_KEY_PREFIX = "ServerBrandCarts";
export var buildServerCartQueryKey = function(queryParams, savedForLater, isOnCartPage, initialServerCart) {
    // Don't include the initial data in the query key
    void initialServerCart;
    return [
        SERVER_CART_QUERY_KEY_PREFIX,
        queryParams,
        savedForLater,
        isOnCartPage
    ];
};
export var SERVER_CART_SUMMARY_QUERY_KEY_PREFIX = "ServerCartSummary";
export var buildServerCartSummaryQueryKey = function(queryParams, selectedBrandTokens, activeTab, isOnCartPage, initialServerCartSummary) {
    // Don't include the initial data in the query key
    void initialServerCartSummary;
    return [
        SERVER_CART_SUMMARY_QUERY_KEY_PREFIX,
        queryParams,
        selectedBrandTokens,
        activeTab,
        isOnCartPage
    ];
};
